<template>
  <div>
    <b-form v-if="show">
      <h4>
        Add questions in your care strategy that require daily or weekly
        responses. All family administrators will receive notifications with the
        answers at the conclusion of each day or week.
      </h4>
      <b-form-group
        id="input-group-1"
        label="Add Question"
        label-for="input-1"
        description="Include queries that necessitate recurring responses, and please ensure they are in the form
            of yes-or-no questions. For example: Did Mary have a restful night's sleep?"
      >
        <b-form-textarea
          id="question"
          v-model="form.question"
          type="text"
          placeholder="Add question"
          required
        />
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Frequency"
        label-for="input-1"
        description="How often must this question be answered?"
      >
        <b-button-group>
          <b-button variant="warning">Daily</b-button>
          <b-button variant="warning">Weekly</b-button>
          <b-button variant="warning">Monthly</b-button>
        </b-button-group>
      </b-form-group>
      <b-button type="save" variant="primary pill">
        Add
      </b-button>
      <b-button type="reset" variant="danger">
        Reset
      </b-button>
    </b-form>
    <b-card v-if="debug" class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      debug: true,
      form: {
        question: "",
        dosage: null,
        frequency: "",
        reason: "",
        notes: "",
        isTaking: "",
        food: null,
        photos: {
          medication: {
            imgURL: ""
          },
          label: {
            imgURL: ""
          }
        }
      },
      foods: [
        { text: "Select One", value: null },
        "Carrots",
        "Beans",
        "Tomatoes",
        "Corn"
      ],
      show: true
    };
  },
  methods: {
    handleSaveClick(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.question = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
